export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отримувач:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Користувача не знайдено"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Контакти"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Докладніше"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вибір користувачів"])}
}